package com.klantenstop.web.data.models.dto.responses

import com.klantenstop.web.data.models.domain.Status
import kotlinx.serialization.Serializable

@Serializable
data class CompanyPinDto(
    val id: String = "",
    val slug: String = "",
    val name: String = "",
    val address: AddressDto? = null,
    val status: CompanyPinStatusDto = CompanyPinStatusDto()
)

@Serializable
data class CompanyPinStatusDto(
    val text: String = "",
    val status: Status.Type = Status.Type.Unknown
)

@Serializable
data class CompanyPinsDto(
    val items: List<CompanyPinDto> = emptyList(),
    // Only populated when the search resolved to a specific city
    val center: CoordinatesDto? = null
)
